// extracted by mini-css-extract-plugin
module.exports = {"collection":"Collections_collection__UUA0y","text":"Collections_text__KEgMl"};